import { IconProps } from '@models/icons';

function PenIcon({
  size, className, color = 'white', ...rest
}: IconProps) {
  return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
           {...rest} >
          <path
              d="M11.1863 2C11.0155 2.00003 10.8464 2.03407 10.6889 2.10015C10.5314 2.16622 10.3886 2.26301 10.2689 2.38485L3.20582 9.41064C3.15358 9.46298 3.11578 9.52794 3.09608 9.59921L2.01578 13.4562C1.99535 13.5294 1.99475 13.6067 2.01404 13.6802C2.03333 13.7537 2.07182 13.8208 2.12556 13.8745C2.1793 13.9282 2.24637 13.9667 2.31988 13.986C2.3934 14.0053 2.47072 14.0047 2.54393 13.9842L6.40215 12.9043C6.47343 12.8846 6.53841 12.8468 6.59077 12.7945L13.6187 5.73361L13.6204 5.73275C13.7407 5.61326 13.8362 5.47117 13.9013 5.31466C13.9665 5.15814 14 4.9903 14 4.82078C14 4.65126 13.9665 4.48341 13.9013 4.3269C13.8362 4.17038 13.7407 4.02829 13.6204 3.9088L13.6187 3.90794L12.1046 2.3857C11.9849 2.26361 11.842 2.1666 11.6843 2.10038C11.5267 2.03415 11.3574 2.00002 11.1863 2Z"
              fill={color}/>
      </svg>
  );
}

export default PenIcon;
